import React from 'react';
import { Autocomplete, TextField, TextFieldProps } from '@mui/material';
import { Country } from '#types';
import useErrorScrollContext from '../../hooks/useErrorScrollContext';

type Option = {
	label: string;
	value: Country;
};

const options: Option[] = [ { label: 'United States', value: Country.US }, { label: 'Canada (excluding Quebec)', value: Country.CA }, ];

type CountrySelect = {
	id?: string;
	className?: string;
	label: string;
	onChange?: (
		event: React.SyntheticEvent<Element, Event>,
		value: string | undefined
	) => void;
	optional?: boolean;
	value?: string;
	error: boolean;
	helperText?: string;
	onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
	textFieldSlotProps?: TextFieldProps['slotProps'];
	disabled?: boolean;
	variant?: TextFieldProps['variant'];
};

export const CountrySelect: React.FC<CountrySelect> = ( {
	id,
	className,
	label,
	onChange,
	value,
	error,
	helperText,
	onBlur,
	textFieldSlotProps,
	disabled,
	variant,
} ) => {
	const selectedValue = options.find( ( option ) => option.value === value );
	const ref = useErrorScrollContext( !!error );
	return (
		// using freeSolo + forcePopupIcon to allow for passing in '' as the value when none is provided, to avoid warning
		<Autocomplete<Option, undefined, true, true>
			ref={ ref }
			id={ id }
			className={ className }
			onChange={ ( e, o ) => onChange?.( e, typeof o === 'string' ? o : o.value ) }
			options={ options }
			value={ selectedValue || '' }
			forcePopupIcon={ true }
			disableClearable={ true }
			disabled={ disabled }
			renderInput={ ( params ) => (
				<TextField
					{ ...params }
					variant={ variant ? variant : 'outlined' }
					label={ label }
					fullWidth={ true }
					error={ error }
					helperText={ helperText }
					onBlur={ onBlur }
					slotProps={ {
						...params.slotProps,
						...textFieldSlotProps,
						htmlInput: {
							...params.slotProps?.htmlInput,
							...textFieldSlotProps?.htmlInput,
						},
					} }
				/>
			) }
		/>
	);
};
